import React from 'react';
import { Card } from "../../tailwind/card";
import { Badge } from "../../tailwind/badge";
import { Button } from "../../tailwind/button";
import { MoreHorizontal, Globe, Smartphone, Store, User } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../tailwind/dropdown-menu";

const CONTACTS = [
  { id: 1, name: "Arjun Singh", phone: "+91 98765 12345", status: "opted_in", source: "website", date: "Jan 15, 2026" },
  { id: 2, name: "Priya Sharma", phone: "+91 98765 67890", status: "opted_in", source: "pos", date: "Jan 14, 2026" },
  { id: 3, name: "Rahul Verma", phone: "+91 98765 11223", status: "opted_out", source: "manual", date: "Jan 12, 2026" },
  { id: 4, name: "Sneha Gupta", phone: "+91 98765 44556", status: "opted_in", source: "qr_code", date: "Jan 10, 2026" },
  { id: 5, name: "Amit Kumar", phone: "+91 98765 99887", status: "opted_in", source: "website", date: "Jan 08, 2026" },
];

const getSourceIcon = (source) => {
  switch(source) {
    case 'website': return <Globe className="h-3.5 w-3.5" />;
    case 'pos': return <Store className="h-3.5 w-3.5" />;
    case 'manual': return <User className="h-3.5 w-3.5" />;
    default: return <Smartphone className="h-3.5 w-3.5" />;
  }
};

export const OptInTable = () => {
  return (
    <Card className="border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100">
              <th className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Customer</th>
              <th className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Phone Number</th>
              <th className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Status</th>
              <th className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Source</th>
              <th className="text-left text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Date Added</th>
              <th className="text-right text-xs font-semibold text-gray-500 uppercase tracking-wider px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {CONTACTS.map((contact) => (
              <tr key={contact.id} className="hover:bg-gray-50/50 transition-colors">
                <td className="px-6 py-4">
                  <div className="font-medium text-gray-900">{contact.name}</div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">
                  {contact.phone}
                </td>
                <td className="px-6 py-4">
                  {contact.status === 'opted_in' ? (
                    <Badge className="bg-green-100 text-green-700 hover:bg-green-100 border-0 shadow-none font-normal">
                      Opted In
                    </Badge>
                  ) : (
                    <Badge className="bg-red-100 text-red-700 hover:bg-red-100 border-0 shadow-none font-normal">
                      Opted Out
                    </Badge>
                  )}
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2 text-sm text-gray-600 capitalize">
                    {getSourceIcon(contact.source)}
                    {contact.source === 'qr_code' ? 'QR Code' : contact.source}
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-gray-500">
                  {contact.date}
                </td>
                <td className="px-6 py-4 text-right">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" size="icon" className="h-8 w-8 text-gray-400 hover:text-gray-600">
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                      <DropdownMenuItem className="text-red-600">
                        Block Contact
                      </DropdownMenuItem>
                      <DropdownMenuItem>
                        View History
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};